import { Box, Grid, LinearProgress, makeStyles } from "@material-ui/core";
import { Typography } from "@material-ui/core";

import { COLORS } from "../../theme/colors";

const useStyles = makeStyles(() => ({
  root: {
    height: 3,
    width: '70%',
    backgroundColor: COLORS.greyDark,
    position: 'absolute',
    bottom: 10,
    borderRadius: 10,
  },
  bar: {
    backgroundColor: COLORS.greenLogo,
    height: 3,
    borderRadius: 10,
  },
}));

export const AppBox = ({
  app,
  handleClick,
  hideBar = false
}) => {
  const classes = useStyles();

  return (
    <Box
      style={{
        cursor: !app.disabled ? "pointer" : null
      }}
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
      onClick={() => handleClick(app)}
    >
      <Box
        style={{
          border: `1px solid ${COLORS.antiFlashWhite}`,
        }}
        sx={{
          padding: 3,
          height: 70,
          width: 70,
          backgroundColor: !app.disabled ? COLORS.newCultured : COLORS.white,
          borderRadius: '16px',
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          position: "relative"
        }}
      >
        <img
          src={app.icon}
          alt="logo"
        />
        {
          !app.disabled && !hideBar ? (
            <LinearProgress
              variant="determinate"
              value={app.progress}
              style={{
                width: '70%',
                backgroundColor: COLORS.greyDark,
                position: "absolute",
                bottom: 8,
                borderRadius: 10,
              }}
              classes={{
                root: classes.root,
                bar: classes.bar,
              }}
            />
          ) : (null)
        }
      </Box>
      <Grid container direction="column" alignItems="center" style={{ marginTop: 11 }}>
        <Grid item>
          <Typography
            style={{
              color: COLORS.purpleDark,
              fontSize: 13,
              fontWeight: 400,
              whiteSpace: 'pre-wrap',
            }}
          >
            {app.title}
          </Typography>
        </Grid>
        <Grid item>
          {app.subTitle ? (
            <Typography
              style={{
                color: COLORS.purpleDark,
                fontSize: 13,
                fontWeight: 400,
                whiteSpace: 'pre-wrap',
                marginTop: -3,
              }}
            >
              {app.subTitle}
            </Typography>
          ) : null}
        </Grid>
      </Grid>
    </Box>
  );
}